import { render, staticRenderFns } from "./Tournaments.vue?vue&type=template&id=dedfcad4&"
import script from "./Tournaments.vue?vue&type=script&lang=js&"
export * from "./Tournaments.vue?vue&type=script&lang=js&"
import style0 from "./Tournaments.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dedfcad4')) {
      api.createRecord('dedfcad4', component.options)
    } else {
      api.reload('dedfcad4', component.options)
    }
    module.hot.accept("./Tournaments.vue?vue&type=template&id=dedfcad4&", function () {
      api.rerender('dedfcad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/Tournaments.vue"
export default component.exports